import React from "react";
import styled from "styled-components";

export default function ReviewCard({ name, title, text, img, reviewPlace }) {
  return (
    <StyledReviewCard>
      <div className="review-card__review">
        <h1>{title}</h1>
        <p>{text}</p>
      </div>

      <div className="review-card__user">
        <img src={img} alt="reviewer-img" />
        <div>
          <h1>{name}</h1>
          <p>{reviewPlace}</p>
        </div>
      </div>
    </StyledReviewCard>
  );
}

const StyledReviewCard = styled.div`
  border: 1px solid var(--border);
  background-color: var(--white);
  padding: 30px 30px 40px 30px;

  .review-card {
    &__review {
      margin-bottom: 16px;

      h1 {
        color: var(--light-blue);
      font-size: var(--fs-card-title);
        font-style: normal;
      font-weight: var(--fw-semibold);
      line-height: 1.35;
        margin-bottom: 16px;
      }

      p {
        color: var(--text);
      font-size: var(--fs-body-sm);
        font-style: normal;
      font-weight: var(--fw-regular);
      line-height: var(--lh-body);
      text-align: left;
      }
    }

    &__user {
      display: flex;
      align-items: center;
      gap: 10px;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        border: 1px solid var(--border);
      }

      h1 {
        color: var(--text-2);
        font-size: var(--fs-body-sm);
        font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-body);
      }

      p {
        color: var(--text);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 150% */
      }
    }
  }
`;
